import ReviewsAPI from "./Reviews";

const GetReviews = (id, setReviews = () => {}) => {
  return ReviewsAPI(id)
    .then(response => {
      if (response) {
        const { avgRating, reviews, questions, answers } = response || {};
        const responseData = { avgRating, reviewCount: reviews, questionCount: questions, answerCount: answers };
        setReviews(responseData);
        return responseData;
      }
      throw new Error("Failed to get review");
    })
    .catch(err => {
      throw err;
    });
};

export default GetReviews;
